module.exports = __webpack_public_path__ + "static/media/wagon-covered.cef74691.svg";